import React, {FC, useEffect, useState} from 'react'
import {Table, Button, Badge, Dropdown} from 'react-bootstrap'
import FormAdd from '../Profile/FormAdd'
import Api from '../../../../../thesis-and-dissertations/helpers/api'
import Pagination from 'react-bootstrap/Pagination'
import usePagination from 'utils/hooks/usePagination'
import {timestampsFormat} from 'thesis-and-dissertations/helpers/helper'
import AlertModal from '../Profile/AlertModal'

const api = new Api()

type Props = {
  dataFilter: any
  handleStatistic: any
}

const AlumniTableContent: FC<Props> = ({dataFilter, handleStatistic}) => {
  const [showForm, setShowForm] = useState(false)
  const [pagination, setPagination] = useState({
    per_page: 10,
    page: 1,
    total_page: 1,
    total_page_arr: [1, 2, 3, 4, 5],
    total_row: 10,
  })
  const [sorting, setSorting] = useState({
    sort_field: '',
    sort_order: '', // 'asc' atau 'desc'
  })

  const [data, setData] = useState<any>([])
  const [errors, setErrors] = useState<any>({})
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [query, setQuery] = useState<any>({})
  const [id, setId] = useState<any>('')
  const [dataAlert, setDataAlert] = useState<any>({})

  const paginator: any = usePagination({
    totalCount: data?.total,
    pageSize: pagination.per_page || 10,
    currentPage: pagination.page || 1,
  })

  useEffect(() => {
    fetchProfile({...query, ...{per_page: pagination.per_page, page: pagination.page}})
  }, [query, pagination.per_page, pagination.page])

  useEffect(() => {
    setQuery({
      ...query,
      ...dataFilter,
      sort_field: sorting.sort_field,
      sort_order: sorting.sort_order,
    })
  }, [sorting, dataFilter])

  const fetchProfile = (params = {}) => {
    setIsLoading(true)
    api
      .getAlumniProfile({...params})
      .then((response: any) => {
        setIsLoading(false)
        const data = response.data
        setData(data?.data?.profiles)
        handleStatistic(data?.data?.statistics)

        const {profiles} = data?.data
        setPagination({
          ...pagination,
          per_page: profiles?.per_page,
          page: profiles?.current_page,
        })
      })
      .catch((error: any) => {
        setIsLoading(false)
        const {data} = error.response
        setErrors(data?.meta?.error)
      })
  }

  const onChangePerPage = (per_page: number, to_page = 1) => {
    setPagination({
      ...pagination,
      per_page: per_page,
      page: to_page || 1,
    })
  }

  const handleCloseForm = () => {
    setShowForm(false)
    setId('')
  }

  const handleShowView = (id: any) => {
    setShowForm(true)
    setId(id)
  }

  const getBadge = (status: string) => {
    if (status == 'Disetujui')
      return (
        <Badge bg='success' pill>
          Disetujui
        </Badge>
      )

    if (status == 'Menunggu Review')
      return (
        <Badge bg='warning' text='white' pill>
          Menunggu Review
        </Badge>
      )

    return (
      <Badge bg='danger' pill>
        Ditolak
      </Badge>
    )
  }

  const handleCloseAlert = () => {
    setDataAlert({
      showAlertModal: false,
    })
  }

  const handleReload = (isReload: boolean) => {
    if (isReload) {
      setDataAlert({showAlertModal: false})
      fetchProfile()
    }
  }

  const handleDataAlert = (
    showAlertModal: boolean,
    type: string,
    title: string,
    desc: string,
    buttonText: string,
    dataProfile: any
  ) => {
    setDataAlert({
      showAlertModal: showAlertModal,
      type: type,
      title: title,
      desc: desc,
      buttonText: buttonText,
      dataAlert: dataProfile,
    })
  }

  const btnAction = (status: string, data: any) => {
    if (status == 'Disetujui' || status == 'Ditolak')
      return (
        <button
          className='shadow-none btn btn-sm btn-outline me-2 mb-2'
          onClick={() => handleShowView(data?.id)}
        >
          <i className='far fa-eye icon-sm text-black' />
        </button>
      )

    return (
      <>
        <button
          className='shadow-none btn btn-sm btn-outline me-2 mb-2'
          onClick={() => handleShowView(data?.id)}
        >
          <i className='far fa-eye icon-sm text-black' />
        </button>

        <button
          className='shadow-none btn btn-sm btn-outline me-2 mb-2'
          onClick={() =>
            handleDataAlert(
              true,
              'approve',
              'Setujui pengajuan alumni',
              `Apakah Anda yakin ingin menyetuji profil ${data?.nama_lengkap}?`,
              'Ya, setujui',
              data
            )
          }
        >
          <i className='fa fa-check icon-sm text-black' />
        </button>

        <button
          className='shadow-none btn btn-sm btn-outline me-2 mb-2'
          onClick={() =>
            handleDataAlert(
              true,
              'reject',
              'Tolak pengajuan alumni',
              `Apakah Anda yakin ingin menolak pengajuan profil ${data?.nama_lengkap}?`,
              'Ya, tolak',
              data
            )
          }
        >
          <i className='fa fa-close icon-sm text-black' />
        </button>
      </>
    )
  }

  return (
    <div className='my-4'>
      <FormAdd
        showFormModal={showForm}
        id={id}
        handleCloseFormModal={handleCloseForm}
        handleReload={handleReload}
      />

      <AlertModal
        showAlertModal={dataAlert?.showAlertModal}
        handleCloseAlertModal={handleCloseAlert}
        type={dataAlert?.type}
        title={dataAlert?.title}
        desc={dataAlert?.desc}
        buttonText={dataAlert?.buttonText}
        data={dataAlert?.dataAlert}
        handleReload={handleReload}
      />

      <Button
        variant='primary'
        className='mb-3 text-white fw-semibold btn-sm'
        onClick={() => setShowForm(true)}
      >
        <p className=' fw-bold'>Tambah Profil Manual</p>
      </Button>

      <div className='mt-6'>
        <Table responsive hover className='align-middle mb-0'>
          <thead>
            <tr className='fw-bold'>
              <td>Nama Alumni</td>
              <td>Program</td>
              <td>Universitas</td>
              <td>Diajukan</td>
              <td>Status</td>
              <td>Tanggal</td>
              <td>Aksi</td>
            </tr>
          </thead>
          <tbody className='bg-white'>
            {data?.data?.length > 0 ? (
              data?.data?.map((alumni: any) => (
                <tr key={alumni.id}>
                  <td>
                    <div className='d-flex align-items-center px-5'>
                      <img
                        src={alumni?.foto_profil_url}
                        alt={alumni?.nama_lengkap}
                        className='rounded-circle'
                        style={{
                          width: '40px',
                          height: '40px',
                          aspectRatio: '1 / 1',
                          objectFit: 'cover',
                          flexShrink: 0, // biar gak ketarik flexbox
                        }}
                      />

                      <div className='ms-3'>
                        <div className='fw-semibold'>{alumni?.nama_lengkap}</div>
                        <div className='text-muted' style={{fontSize: '0.85rem'}}>
                          {alumni?.gelar_akademik_belakang ?? '-'}
                        </div>
                      </div>
                    </div>
                  </td>

                  <td>
                    <div className='ms-3'>
                      <div className='fw-semibold'>{alumni?.program_beasiswa}</div>
                      <div className='text-muted' style={{fontSize: '0.85rem'}}>
                        {alumni?.batch_pk ?? '-'}
                      </div>
                    </div>
                  </td>

                  <td>
                    <div className='ms-3'>
                      <div className='fw-semibold'>{alumni?.universitas}</div>
                      <div className='text-muted' style={{fontSize: '0.85rem'}}>
                        {alumni?.negara} • {alumni?.tahun_lulus}
                      </div>
                    </div>
                  </td>

                  <td>{alumni?.submitted_by?.fullname}</td>
                  <td>{getBadge(alumni?.status)}</td>
                  <td>{timestampsFormat(alumni?.created_at)}</td>
                  <td>{btnAction(alumni?.status, alumni)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} className='text-center py-5'>
                  <div className='text-muted'>
                    <i className='fa fa-folder-open fa-2x mb-2'></i>
                    <div>Tidak ada data</div>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <div className='row mt-6'>
        <div className='col-md-6'>
          {data?.data?.length > 0 && !isLoading && (
            <div style={{float: 'left'}}>
              <Dropdown>
                <Dropdown.Toggle className='btn btn-sm'>{pagination.per_page}</Dropdown.Toggle>
                <Dropdown.Menu>
                  {[10, 25, 50, 100].map((item: any) => (
                    <Dropdown.Item
                      key={item}
                      href='#/action-1'
                      onClick={() => onChangePerPage(item)}
                      disabled={pagination.per_page === item}
                    >
                      {item}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}
        </div>
        <div className='col-md-6'>
          <div style={{float: 'right'}}>
            {!isLoading && (
              <Pagination className='btn-sm'>
                {paginator?.map((item: any) => {
                  return (
                    <Pagination.Item
                      className='btn-sm'
                      key={item}
                      active={item === pagination.page}
                      onClick={() => onChangePerPage(pagination.per_page, item)}
                      disabled={item === '...'}
                    >
                      {item}
                    </Pagination.Item>
                  )
                })}
              </Pagination>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

const AlumniTable: FC<Props> = ({dataFilter, handleStatistic}) => {
  return <AlumniTableContent dataFilter={dataFilter} handleStatistic={handleStatistic} />
}

export default AlumniTable
